import { render, staticRenderFns } from "./BvaAbusingReports.vue?vue&type=template&id=64cf3a78&"
import script from "./BvaAbusingReports.vue?vue&type=script&lang=ts&"
export * from "./BvaAbusingReports.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports